<template>
  <v-dialog v-model="open" width="500">
    <v-card>
      <v-card-title>
        New CSM Note
      </v-card-title>
      <v-card-text>
        <v-textarea
            v-model="text"
            solo
            name="input-7-4"
            label="Type here"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn v-if="!loading" color="primary" text :disabled="text === null"
               @click="save">
          Save
        </v-btn>
        <v-progress-circular v-if="loading" indeterminate :size="20" color="primary"/>
        <v-btn :disabled="loading" color="primary" text @click="close">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '../../../services/reporting.api';
import {mapActions} from "vuex";
import i18n from '../../../setup/locale/en';

export default {
  props: {
    isOpen: Boolean,
    clientId: Number,
  },
  watch: {
    isOpen(newValue) {
      this.open = newValue;
    },
    open(newValue, prevValue) {
      if (prevValue && !newValue) {
        this.close();
      }
    },
  },
  data: () => ({
    loading: false,
    open: false,
    text: null,
  }),
  mounted() {
    this.open = this.isOpen;
  },
  methods: {
    ...mapActions('healthScoreStore', ['addCsmNote']),
    ...mapActions("whizeosupportToolsStore", ["SHOW_SNACKBAR"]),
    async save() {
      this.loading = true;
      try {
        const newNote = await api.addCsmNote({
          clientId: this.clientId,
          text: this.text
        });
        await this.addCsmNote(newNote);
        this.close();
      } catch (error) {
        const errorMessage = {
          visible: true,
          color: "error",
          message: i18n.clients.healthScore.errors.addNote,
        };

        this.SHOW_SNACKBAR(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit('close');
      this.text = null;
    }
  }
}
</script>
